import { createVueApp } from "../../libs/app"
createVueApp("login")
